import React, { useEffect, useState } from "react";
import "./MCQResult.css";
import { useNavigate } from "react-router-dom";

const MCQResult = () => {
  const [result, setResult] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const stored = localStorage.getItem("latestMCQResult");
    if (stored) {
      setResult(JSON.parse(stored));
    }
  }, []);

  if (!result) return <p className="loading">Loading result...</p>;

  const percentageScore = ((result.score / result.answers.length) * 100).toFixed(1);

  return (
    <div className="mcq-container">
      <div className="mcq-card">
        <h2 className="mcq-title">{result.quizTitle}</h2>
        <p className="mcq-date">
          Submitted At: {new Date(result.submittedAt).toLocaleString()}
        </p>

        <div className="mcq-info">
          <div className="mcq-info-block">
            <p className="mcq-info-label">Duration</p>
            <p className="mcq-info-value">{result.timeTaken || " "}</p>
          </div>
          <div className="mcq-info-block">
            <p className="mcq-info-label">Max Marks</p>
            <p className="mcq-info-value">{result.maxMarks || " "}</p>
          </div>
          <div className="mcq-info-block">
            <p className="mcq-info-label">Questions</p>
            <p className="mcq-info-value">{result.answers.length}</p>
          </div>
        </div>

        <div className="mcq-score-summary">
          <div className="mcq-score-box">
            <p className="mcq-score-label">Your Result</p>
            <p className="mcq-score-value">{percentageScore}%</p>
          </div>
          <div className="mcq-score-box">
            <p className="mcq-score-label">Accuracy</p>
            <p className="mcq-score-value">{result.accuracy}%</p>
          </div>
        </div>

        <p className="mcq-score-detail">
          Score: {result.score} / {result.answers.length} ({percentageScore}%)
        </p>

        {!showDetails ? (
          <button className="mcq-button" onClick={() => setShowDetails(true)}>
            View Result
          </button>
        ) : (
          <>
            <h3 className="mcq-subtitle">📋 Answer Summary</h3>
            {result.answers.map((ans, i) => (
              <div className="mcq-question" key={i}>
                <h4>Q{i + 1}</h4>
                <p>✅ Correct Answer: {ans.correct}</p>
                <p>🧠 Your Answer: {ans.selected || "Not attempted"}</p>
                <p><strong>Explanation:</strong> {ans.explanation}</p>
              </div>
            ))}
          </>
        )}

        <button
          className="mcq-button back"
          onClick={() => {
            localStorage.removeItem("latestMCQResult");
            navigate("/dashboard");
          }}
        >
          🔙 Back to Dashboard
        </button>
      </div>
    </div>
  );
};

export default MCQResult;
